import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26199d4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-banner" }
const _hoisted_2 = ["src", "poster"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_4 = { class: "h-banner__wrap" }
const _hoisted_5 = { class: "h-banner_slogan" }
const _hoisted_6 = { class: "h-search" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_z_search = _resolveComponent("z-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      ref: "videoRef",
      id: "video",
      loop: "",
      src: _ctx.bgUrl,
      muted: "",
      autoplay: "",
      class: "h-banner_video",
      poster: _ctx.poster
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.bgSlogan), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_z_search, {
          theme: "light",
          onInputChange: _ctx.handleSearchChange
        }, null, 8, ["onInputChange"])
      ])
    ])
  ]))
}